export default "__VITE_ASSET__DbRlSZvq__"